import { FiClipboard } from "react-icons/fi";
import { Prescription } from "../../../../types";

interface WorkoutPlanFooterProps {
  prescriptions: Prescription[];
  initialData?: { id?: number } | null;
  loading: boolean;
  onClose: () => void;
}

export const WorkoutPlanFooter = ({
  prescriptions,
  initialData,
  loading,
  onClose,
}: WorkoutPlanFooterProps) => {
  return (
    <div className="border-t border-stroke bg-white px-3 py-3 sm:px-4 sm:py-4 md:px-8 md:py-5 dark:border-strokedark dark:bg-boxdark">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        {/* Info - Mobile First */}
        <div className="text-xs sm:text-sm text-gray-600 dark:text-gray-400 text-center sm:text-left">
          {prescriptions.length > 0 && (
            <span>
              <strong className="font-semibold text-gray-900 dark:text-white">
                {prescriptions.length}
              </strong>{" "}
              {prescriptions.length === 1 ? "treino" : "treinos"} •{" "}
              <strong className="font-semibold text-gray-900 dark:text-white">
                {prescriptions.reduce((acc, p) => acc + p.exercises.length, 0)}
              </strong>{" "}
              exercícios
            </span>
          )}
        </div>

        {/* Buttons - Mobile First */}
        <div className="flex flex-col-reverse gap-2 sm:flex-row sm:gap-3">
          <button
            type="button"
            onClick={onClose}
            className="w-full sm:w-auto rounded-lg sm:rounded-xl border-2 border-stroke px-4 py-2.5 sm:px-6 sm:py-3 text-sm sm:text-base font-semibold text-gray-700 transition-all active:bg-gray-50 md:hover:bg-gray-50 dark:border-strokedark dark:text-white dark:active:bg-meta-4 md:dark:hover:bg-meta-4 touch-manipulation"
          >
            Cancelar
          </button>
          <button
            type="submit"
            disabled={loading}
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 rounded-lg sm:rounded-xl bg-gradient-to-r from-purple-600 to-purple-600 px-4 py-2.5 sm:px-8 sm:py-3 text-sm sm:text-base font-semibold text-white shadow-sm transition-all active:scale-95 md:hover:scale-105 md:hover:shadow-xl disabled:opacity-50 disabled:active:scale-100 disabled:md:hover:scale-100 touch-manipulation"
          >
            {loading ? (
              <>
                <div className="h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent"></div>
                Salvando...
              </>
            ) : (
              <>
                <FiClipboard size={16} className="sm:w-[18px] sm:h-[18px]" />
                {initialData ? "Atualizar Plano" : "Criar Plano"}
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};
